<div class="home">
  <div class="home__container">

    <section class="home__container-section-hero">
      <!-- <div class="hero-section2"> -->
      <!-- <div class="home__GRC-section-container" >
        <div class="home__GRC-section-description">
            <h1  [innerHTML]="'Automate Your GRC Program'" l10nTranslate></h1>
            <h4 *ngIf="currentLanguage === 'ar'"  [innerHTML]="'Elevate your GRC program'" l10nTranslate></h4>
            <h4  [innerHTML]="'and Prepare Your Organization for Scalable'" l10nTranslate></h4>
            <h4  [innerHTML]="'Growth with Our Advanced All-in-One Platform'" l10nTranslate></h4>
            <ngu-carousel #myCarousel [inputs]="carouselConfig" [dataSource]="dynamicTextArray">
              <div *nguCarouselDef="let item;" class="item">
                <div class="home__container-compliance">{{item}}</div>
              </div>

            </ngu-carousel>
            <p  l10nTranslate>
              Comprehensive solutions to mitigate Cyber Risks and automate GRC operations
            </p>
            <div class="home__GRC-section__btn_holder">
              <button class="home__GRC-section-btn" [routerLink]="['/contact-us']" l10nTranslate>Request a demo</button>
            </div>
        </div>
        <div class="home__hero-section-background">
            <img [src]="imagePath2" alt="hero-section" >
        </div>
      </div> -->
      <!-- </div> -->
       <div class="home__container_info-holder">
          <img src="../../../../assets/images/star.png">
          <div class="home__container_info" l10nTranslate>The Leading GRC Automation Platform</div>
       </div>

      <div class="home__container_title" l10nTranslate>
        <span l10nTranslate class="color-primary">Automate-2 </span>
        <span l10nTranslate>Compliance-2 </span>
        <span class="color-orange" l10nTranslate> Mitigate </span>
         <br *ngIf="!commonService.isMobile"> 
         <span l10nTranslate>Risks-2</span> 
        <span *ngIf="currentLanguage === 'en'" l10nTranslate>and</span>
        <span l10nTranslate class="color-green"> Pass </span>
        <span l10nTranslate>Audit Confidently</span>
         </div>
      <div l10nTranslate [innerHTML]="'Join Government Entities, leading Businesses, and fast-growing Startups who trust our platforms to simplify how they Govern, Protect, and Comply'" class="home__container_description-2"></div>
        <div class="home__container_features">
          <div class="home__container_features-item">
            <img src="../../../../assets/images/correct.png">
            <div class="home__container_features-item-text" l10nTranslate>Fast Deployment-2</div>
          </div>
          <div class="home__container_features-item">
            <img src="../../../../assets/images/correct.png">
            <div class="home__container_features-item-text" l10nTranslate>Seamless Integration</div>
          </div>
          <div class="home__container_features-item">
            <img src="../../../../assets/images/correct.png">
            <div class="home__container_features-item-text" l10nTranslate>Immediate Impact</div>
          </div>
        </div>
      <!-- <ngu-carousel #myCarousel [inputs]="carouselConfig" [dataSource]="dynamicTextArray">
        <div *nguCarouselDef="let item;" class="item">
          <div class="home__container-compliance">{{item}}</div>
        </div>

      </ngu-carousel> -->
      <div class="home__container-btn-holder">
      <button class="btn__book-demo" [routerLink]="['/contact-us']" l10nTranslate>Request a demo</button>
      <a class="hero-section__btn-data-sheet" l10nTranslate [routerLink]="['/products-grc']" target="_blank" href="">Learn more</a>
      </div>

      <!-- <div class="circle__top-right"><img src="../../../../assets/images/circle-top-header.png"></div> -->
      <!-- <div class="triangle__bottom-left"><img src="../../../../assets/images/triangle-bottom-left.png"></div> -->
    </section>
    <!-- <section class="home__holder__partners"> -->

      <section class="home__container-advantage">
        <h2 class="home__container-advantage-title" l10nTranslate>Proven Impact</h2>
        <div class="home__container-advantage-description" l10nTranslate>We transform GRC into competitive advantages that drive business growth</div>
        <div class="home__container-advantage-percentage-holder">
          <div class="home__container-advantage-percentage-item">
            <div class="home__container-advantage-percentage-item-value">90%</div>
            <div class="home__container-advantage-percentage-item-label" [innerHTML]="'Less operational overhead'" l10nTranslate></div>
          </div>
          <div class="home__container-advantage-percentage-item">
            <div class="home__container-advantage-percentage-item-value" l10nTranslate>3 months</div>
            <div class="home__container-advantage-percentage-item-label" [innerHTML]="'RIO achieved in three months'" l10nTranslate></div>
          </div>
          <div class="home__container-advantage-percentage-item">
            <div class="home__container-advantage-percentage-item-value">100%</div>
            <div class="home__container-advantage-percentage-item-label" [innerHTML]="'Increase in team productivity'" l10nTranslate></div>
          </div>
        </div>
      </section>

    <section class="home__container__partners">
      <h2 l10nTranslate>Trusted by Leading Organizations</h2>
      <div class="home__container__partners-sliders-1" *ngIf="!commonService.isMobile">
        <div>
          <img src="../../../../assets/images/Haj.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SCF.png" height="100%" style="object-fit: cover;" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Bahri.png" alt="" width="75%" />
        </div>
        <div>
          <img src="../../../../assets/images/NWC.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/CST.svg" height="135%" style="object-fit: cover;" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Modon.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SIDF.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Mawani.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SSA.webp" alt="" width="90%" />
        </div>
      </div>  
      <div class="home__container__partners-sliders-1" *ngIf="commonService.isMobile">
        <div>
          <img src="../../../../assets/images/Haj.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SCF.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Bahri.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/NWC.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/CST.svg"  alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Modon.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SIDF.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Mawani.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SSA.webp" alt="" />
        </div>
      </div> 



      <div class="home__container__partners-sliders-2" *ngIf="!commonService.isMobile">
        <div>
          <img src="../../../../assets/images/Wakeb.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/tree-logo.svg" height="85%" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/TGA.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SRC.webp" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SEU.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SJSC.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/HRDA.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/EIF.png" height="90%" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/DATASAD.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/BLOM.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Aman.png" height="95%" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/EXIM.png" height="140%" style="object-fit: cover;" alt="" />
        </div>
      </div> 
      <div class="home__container__partners-sliders-2" *ngIf="commonService.isMobile">
        <div>
          <img src="../../../../assets/images/Wakeb.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/tree-logo.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/TGA.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SRC.webp" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SEU.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/SJSC.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/HRDA.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/EIF.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/DATASAD.svg" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/BLOM.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/Aman.png" alt="" />
        </div>
        <div>
          <img src="../../../../assets/images/EXIM.png"  alt="" />
        </div>
      </div> 
    </section>
    <!-- </section> -->

    <!-- <section class="home__container-section-products">
      <div class="section__fab" l10nTranslate>
        Products
      </div>
      <div>
        <h2 l10nTranslate>Explore Full Automation</h2>
        <div class="home__container_description" l10nTranslate>To mitigate Cyber Risks and automate GRC operations</div>
      </div>
      <div class="home__products-card">
        <div class="home__products-cards-row">
          <div class="home__product-card-holder">
            <div class="home__product-card">
              <div class="home__product-card-content">
                <img class="home__product-card-content-logo" src="../assets/svg/Easycompliance®.svg" alt="Easycompliance">
                <h4 [innerHTML]="'GRC Automation2'" l10nTranslate></h4>
                <img class="home__product-card-content-img" *ngIf="currentLanguage == 'en'" src="../assets/images/Frame227.png" alt="GRC Automation">
                <img class="home__product-card-content-img" *ngIf="currentLanguage == 'ar'" src="../assets/images/Frame227Ar.png" alt="GRC Automation">
                <div *ngIf="!commonService.isMobile" class="home__product-card-content-description" l10nTranslate [innerHTML]="'Easier Compliance Faster Audits and Better Risk Visibility'"></div>
                <div *ngIf="commonService.isMobile" class="home__product-card-content-description" l10nTranslate [innerHTML]="'Easier Compliance Faster Audits and Better Risk Visibility2'"></div>
              </div>
              <button class="btn__learn-more" [routerLink]="['/products-grc']" l10nTranslate>Learn more</button>
            </div>
          </div>
          <div class="home__product-card-holder">
            <div class="home__product-card">
              <div class="home__product-card-content">
                <img class="home__product-card-content-logo" src="../assets/svg/awareness 10®.svg" alt="awareness 10">
                <h4 l10nTranslate>
                  <div l10nTranslate>Cybersecurity Awareness-2</div>
                  <div l10nTranslate> & Phishing Simulation</div>
                </h4>
                <img class="home__product-card-content-img" *ngIf="currentLanguage == 'en'" src="../assets/images/simulationn.png" alt="Awareness">
                <img class="home__product-card-content-img" *ngIf="currentLanguage == 'ar'" src="../assets/images/Rectangle4308-ar.png" alt="Awareness">
                <div *ngIf="!commonService.isMobile" class="home__product-card-content-description" l10nTranslate [innerHTML]="'Assess employees readiness with realistic phishing and launch awereness campaigns2'"></div>
                <div *ngIf="commonService.isMobile" class="home__product-card-content-description" l10nTranslate [innerHTML]="'Assess employees readiness with realistic phishing and launch awereness campaigns3'"></div>
              </div>
              <button class="btn__learn-more" [routerLink]="['/products-awareness']" l10nTranslate>Learn
                more</button>
            </div>
          </div>
        </div>
      </div>
    </section> -->



    <section class="home__container-section-products">
      <!-- <div>
        <h2 l10nTranslate>Explore Full Automation</h2>
        <div class="home__container_description" l10nTranslate>To mitigate Cyber Risks and automate GRC operations</div>
      </div> -->
        <div class="home__products-cards-row">
          <div class="home__product-card-holder">
            <div class="home__product-LMS-holder">
              <div class="home__products_info-holder">
                <img src="../../../../assets/images/Group39233.png">
                <div class="home__container_info" l10nTranslate>Awareness is your first cyber defense</div>
            </div>
              <div class="home__product-LMS-title" l10nTranslate>Cybersecurity Awareness LMS</div>
              <div class="home__product-LMS-subtitle" l10nTranslate>Build a Cyber-Aware Workforce </div>
              <ul>
                <li l10nTranslate>Trusted by leading clients with thousands of users</li>
                <li l10nTranslate> 100% Guaranteed Phishing Simulation Email Delivery</li>
                <li l10nTranslate> Train on realistic attacks scenarios</li>
                <li l10nTranslate> NCA Compliant Awareness Library</li>
                <li l10nTranslate> Localized content in Arabic & English</li>
                <li l10nTranslate>Class (C) Cloud Hosting with On-prem hosting option</li>
              </ul>
        <div class="home__product-features">
          <div class="home__product-features-item">
            <!-- <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png"> -->
            <div class="home__container_features-percentage" l10nTranslate>60%</div>
            
            <div class="home__product-features-item-text" [innerHTML]="'Employees Behavioral Change'" l10nTranslate></div>
          </div>

          <div class="home__product-features-item">
            <div class="home__container_features-percentage" l10nTranslate>90%</div>
            <div class="home__product-features-item-text" [innerHTML]="'Faster response to new threats'" l10nTranslate></div>
          </div>
          <div class="home__product-features-item">
            <div class="home__container_features-percentage" l10nTranslate>1 Week</div>
            <div class="home__product-features-item-text" [innerHTML]="'Meet regulatory requirements in one week'" l10nTranslate></div>
          </div>
        </div>
              <div class="home__product-LMS-btn-holder">
                <button class="btn__learn-more" [routerLink]="['/contact-us']" l10nTranslate>Request a demo</button>
                <a class="hero-section__btn-data-sheet" l10nTranslate [routerLink]="['/products-awareness']" target="_blank" href="">Learn more</a>
              </div>
            </div>
          </div>
          <div class="home__product-card-holder">
              <div class="home__product-card-content">
                <img *ngIf="currentLanguage == 'en'" class="home__product-card-content-logo" src="../assets/images/simulationn.png" alt="awareness 10">
                <img *ngIf="currentLanguage == 'ar'" class="home__product-card-content-logo" src="../assets/images/Rectangle4308-ar.png" alt="Awareness">
              </div>
          </div>
        </div>
    </section>


    <section class="home__container-section-solidrange">
      <div class="home__container__solidrange-content">
        <div class="home__container__solidrange-content-row">
          <div class="section-solidrange-description">
            <h2 l10nTranslate>Why Solidrange</h2>
            <p l10nTranslate>We are committed to deliver the best client experience with our solutions services and
              support We provide well researched and well designed platforms combined with consulting and integration
              services to ensure the best possible results for you to manage the cybersecurity human risk at the
              workplace and uplift your GRC program maturity</p>
            <div class="home__-solidrange-fabs-holder">
              <div class="home__container-solidrange-fab" l10nTranslate>Designed by Experts</div>
              <div class="home__container-solidrange-fab" l10nTranslate>Cost Effective</div>
              <div class="home__container-solidrange-fab" l10nTranslate>Fast Deployment</div>
              <div class="home__container-solidrange-fab" l10nTranslate>Cloud and On-prem Options</div>
              <div class="home__container-solidrange-fab" l10nTranslate>Reliable Support</div>
              <div class="home__container-solidrange-fab" l10nTranslate>Authorized by Regulators</div>
            </div>

          </div>

          <div class="home__container-solidrange-logo">
            <img *ngIf="currentLanguage == 'en'" src="../../../../assets/images/undraw_questions_re_1fy7 1.png">
            <img *ngIf="currentLanguage == 'ar'" src="../../../../assets/images/undraw_questions_re_ar.png">
          </div>
        </div>

      </div>
      <div class="section__solidraneg-isolation">
        <img src="../../../../assets/images/Isolation_Mode.png">
      </div>
    </section>

    <section class="home__container-section-herosection">

      <app-hero-section [header]="header" [isKsaImg]="isKsaImg" [imagePath]="imagePath" [description]="description"
        [joinChat]="joinChat" [hasBtn]="true" [routerButton]="routerHeroButton" [buttonText]="buttonHeroText">
      </app-hero-section>

    </section>
    <section class="home__container-section-services">
      <div class="section__fab" l10nTranslate>
        Services
      </div>

      <div class="home__container-services_cards">
        <h2 l10nTranslate>Get Experts Support</h2>

        <div class="home__container_description" l10nTranslate>Learn about the services provided by our experts to support you in implementing your cybersecurity programs</div>

        <div class="home__container-services_cards-row">
          <div class="home__container-services-card-holder" *ngFor="let item of sectionInputCards">
            <div class="home__container-services-card" [routerLink]="[item.link]">
              <mat-icon class="home__container-services-card-logo" [svgIcon]="item.imagePath"></mat-icon>
              <h3 [innerHTML]="item.title" l10nTranslate></h3>
              <div class="home__container-services-card-description" l10nTranslate>
                {{item.description}}
              </div>
            </div>
          </div>


        </div>


      </div>
      <button class="btn__learn-more" [routerLink]="['/services']" l10nTranslate>Learn more</button>

    </section>
    <section class="home__container-section-reliable-support">
      <app-image-with-text [isHomePage]="true" [imageText]="imageText" [routerLink]="routerLink" [imageUrl]="imageUrl"
        [buttonText]="buttonText" [routerButton]="routerButton" [imageTextPath]="imageTextPath"></app-image-with-text>
    </section>
    <!-- <section class="home__container-section-carousel">
      <div class="home__container-section-carousel-row">

        <ngu-carousel  [inputs]="clientsReviewConfig" [dataSource]="clientsReview">
          <div *nguCarouselDef="let item;" class="item">
            <div class="carousel-cell">
              <div class="images__carousel">
                <div class="rectangle-holder">
                  <div class="rectangle">
                  </div>
                </div>


                <div class="carousel__content">
                  <div class="quote"><img src="../../../../assets/images/quote.png"></div>
                  <div class="carousel__content-description"
                       [innerHTML]="item.msg"
                       l10nTranslate>
                  </div>
                  <h1 class="carousel__content-header"
                      [innerHTML]="item.position"
                      l10nTranslate>
                  </h1>
                </div>
              </div>

            </div>
          </div>
          <div NguCarouselNext class="carousel-arrow carousel-arrow-prev"></div>
          <div NguCarouselPrev class="carousel-arrow carousel-arrow-next"></div>
        </ngu-carousel>

      </div>



    </section> -->
    <!-- <section class="home__partners">
      <div class="home__partners-container">
        <div class="home__partners-row">
          <div class="home__partners-header" [innerHTML]="'Trusted by Leading Organizations'" l10nTranslate> </div>
          <div class="home__carousel-partners">


            <ngu-carousel  [inputs]="partnersReviewConfig" [dataSource]="partners">
              <div *nguCarouselDef="let item;" class="item">
                <div class="carousel-cell-images">
                  <img [src]="item" />

                </div>
              </div>
              <div NguCarouselNext class="carousel-arrow carousel-arrow-prev"></div>
              <div NguCarouselPrev class="carousel-arrow carousel-arrow-next"></div>
            </ngu-carousel>



          </div>

        </div>
      </div>
      <div class="section__partners-isolation">
        <img src="../../../../assets/images/Isolation_Mode.png">
      </div>

    </section> -->
    <!-- <section class="home__container-all-blogs">
      <h2 l10nTranslate>News Blogs</h2>
      <div class="home__container-blogs-filter-results">
        <div class="home__container-blogs-filter-result-card" *ngFor="let blog of blogs">
          <div class="home__container-blogs-filter-result-card-info">
            <img [src]="blog.url" alt="blog-img">
            <div class="home__container-blogs-filter-result-card-type">
              <span class="home__container-blogs-filter-result-card-type-news" l10nTranslate>News</span>
              <span class="home__container-blogs-filter-result-card-type-cybersecurity"
                l10nTranslate>Cybersecurity</span>
            </div>
            <div class="home__container-blogs-filter-result-card-details">
              <div class="home__container-blogs-filter-result-card-title" l10nTranslate>{{blog.title}}</div>
              <div class="home__container-blogs-filter-result-card-Lorem">July 5 ,2023</div>
              <button class="home__container-blogs-filter-btn-read-more" (click)="blogDetailsNavigation(blog.id)"
                l10nTranslate>Read more</button>
            </div>
          </div>
        </div>
      </div>
      <button class="btn__view-all-blogs" [routerLink]="['/blogs']" l10nTranslate>View All</button>

    </section> -->


  </div>
</div>

